module.exports = __webpack_public_path__ + "img/img-shili.a527d591.png";